import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.concat.js";
import { getRem } from './getRem';
export function getArrayRem(value) {
  if (!value) return null;
  return value.reduce(function (result, item) {
    return "".concat(result, " ").concat(getRem(item));
  }, '').toString().trim();
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9nZXRBcnJheVJlbS50cyJdLCJuYW1lcyI6WyJnZXRSZW0iLCJnZXRBcnJheVJlbSIsInZhbHVlIiwicmVkdWNlIiwicmVzdWx0IiwiaXRlbSIsInRvU3RyaW5nIiwidHJpbSJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsU0FBU0EsTUFBVCxRQUF1QixVQUF2QjtBQUVBLE9BQU8sU0FBU0MsV0FBVCxDQUFxQkMsS0FBckIsRUFBa0Q7QUFDdkQsTUFBSSxDQUFDQSxLQUFMLEVBQVksT0FBTyxJQUFQO0FBRVosU0FBT0EsS0FBSyxDQUNUQyxNQURJLENBQ0csVUFBQ0MsTUFBRCxFQUFTQyxJQUFUO0FBQUEscUJBQXFCRCxNQUFyQixjQUErQkosTUFBTSxDQUFDSyxJQUFELENBQXJDO0FBQUEsR0FESCxFQUNrRCxFQURsRCxFQUVKQyxRQUZJLEdBR0pDLElBSEksRUFBUDtBQUlEIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgZ2V0UmVtIH0gZnJvbSAnLi9nZXRSZW0nO1xuXG5leHBvcnQgZnVuY3Rpb24gZ2V0QXJyYXlSZW0odmFsdWU/OiAoc3RyaW5nIHwgbnVtYmVyKVtdKSB7XG4gIGlmICghdmFsdWUpIHJldHVybiBudWxsO1xuXG4gIHJldHVybiB2YWx1ZVxuICAgIC5yZWR1Y2UoKHJlc3VsdCwgaXRlbSkgPT4gYCR7cmVzdWx0fSAke2dldFJlbShpdGVtKX1gLCAnJylcbiAgICAudG9TdHJpbmcoKVxuICAgIC50cmltKCk7XG59XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./~/@utex/ui-kit/dist/utils/getArrayRem.js
// module id = 800
// module chunks = 118